import React from 'react';
import { withTranslation } from 'react-i18next';
import { Field } from 'redux-form'
import { FormGroup,  Button, ModalHeader, ModalBody } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { numberOnly } from 'lib/fp-utility';

class CupCardBeanOTPModal extends React.Component {
    state = {otp: null}
    submitOTPPassword = this.submitOTPPassword.bind(this)

    submitOTPPassword(){
        console.log(this.state.otp)
        this.props.validateOTP(this.state.otp, this.props.paymentRequest)
    }

    validOTP(val){
        return !(val && val.length > 5)
    }

    render() {
        const { t } = this.props
        return (
            <>
                <ModalHeader toggle={this.props.closeSelfOTP}>{t('otp_popup_title')} (OTP)</ModalHeader>
                <ModalBody>
                    <div className="text-center mb-3">
                        <p className="text-16">{t('otp_popup_content1')}</p>
                        <p className="text-16">OTP: {t('otp_popup_content2')}</p>
                        <FormGroup>
                            <form action={this.props.selfOTPTermUrl} name='OTPACSFORM' method="POST">
                                <Field className="text-center" maxLength={10} name="otp"  onChange={(e)=> this.setState({otp: e.target.value})} component='input' placeholder="OTP" normalize={(value) => numberOnly(value)} />
                            </form>
                        </FormGroup>
                    </div>
                    <div className="text-center" role="group">
                        {/* <Button outline color="secondary" disabled={this.props.disableOTPBtn} onClick={this.props.resendOTP}>{t('Resend')} OTP</Button> */}
                        <Button disabled={this.validOTP(this.state.otp)} onClick={this.submitOTPPassword}>{t('Continue')}</Button>
                    </div>
                </ModalBody>
            </>
        )
    }
}

export default withTranslation('translations')(modalWrapper(true, "CardOTPModal")(CupCardBeanOTPModal));